import { useTranslation } from '../../i18n';
import React, { useEffect, useRef } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { interpretTTE, interpretTAE } from '../../utils/interpretTraining';

const StrengthPhysiologicalAnalysis = ({ completed = {}, metrics = {}, athleteId, activityId, banister, date }) => {
  const { t, language } = useTranslation();
  const rootRef = useRef(null);
  const avgHR = metrics?.ritmo_cardiaco?.avg ?? 0;
  const maxHR = metrics?.ritmo_cardiaco?.max ?? 0;
  const tss = parseFloat(completed.tss) || 0;
  const te = parseFloat(completed.te) || 0;
  const tea = parseFloat(completed.tea) || 0;

useEffect(() => {
  if (!completed || Object.keys(completed).length === 0) return;
  const el = document.getElementById('chartdiv-strength');
  if (!el) return;

  if (rootRef.current) {
    try { rootRef.current.dispose(); } catch (_) {}
    rootRef.current = null;
  }

  const root = am5.Root.new("chartdiv-strength");
  rootRef.current = root;
  root.setThemes([am5themes_Animated.new(root)]);

  const chart = root.container.children.push(
    am5xy.XYChart.new(root, { layout: root.verticalLayout })
  );

  chart.set("cursor", am5xy.XYCursor.new(root, {
    behavior: "none", xAxis: null, yAxis: null
  }));

  const xAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
      tooltip: am5.Tooltip.new(root, {})
    })
  );

  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {})
    })
  );

  const series = chart.series.push(
    am5xy.ColumnSeries.new(root, {
      name: "valor",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      categoryXField: "category"
    })
  );

  const data = [
    { category: "TSS", value: isFinite(tss) ? Number(tss.toFixed(2)) : 0, label: `TSS: ${tss.toFixed(2)}` },
    { category: "TTE", value: isFinite(te) ? Number(te.toFixed(1)) : 0, label: `TTE: ${te.toFixed(1)}` },
    { category: "TEA", value: isFinite(tea) ? Number(tea.toFixed(1)) : 0, label: `TEA: ${tea.toFixed(1)}` },
    { category: t("physio.avgHR"), value: isFinite(avgHR) ? Math.round(avgHR) : 0, label: `${t("physio.avgHR")}: ${Math.round(avgHR)}` },
    { category: t("cycling.maxHR"), value: isFinite(maxHR) ? Math.round(maxHR) : 0, label: `${t("cycling.maxHR")}: ${Math.round(maxHR)}` }
  ];

  xAxis.data.setAll(data);
  series.data.setAll(data);

series.set("tooltip", am5.Tooltip.new(root, {
  labelText: "{categoryX}: {valueY.formatNumber('#.0')}",
  pointerOrientation: "down"
}));


  series.columns.template.adapters.add("tooltipText", (_, target) => {
    return target.dataItem?.dataContext?.label ?? "";
  });

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [tss, te, tea, avgHR, maxHR]);
  return (
    <div className="mt-4">
      <h5 style={{ fontSize: 14, fontWeight: 700, color: '#193255' }}>📊 {t('athleteDashboard.runningPhysio.title')}</h5>
      <p>{t('athleteDashboard.runningPhysio.tssSentence', { tss: tss.toFixed(2), duration: completed?.duracion > 0 ? (parseFloat(completed.duracion) / 60).toFixed(0) : (tss * 0.7).toFixed(0), load: tss >= 100 ? t('athleteDashboard.runningPhysio.loadHigh') : t('athleteDashboard.runningPhysio.loadModerate') })}</p>
      {avgHR > 0 && <p>{t('athleteDashboard.runningPhysio.hrSentence', { avg: Math.round(avgHR), max: Math.round(maxHR) })}</p>}
      {te > 0 && <p>{t('athleteDashboard.runningPhysio.tteSentence', { value: te.toFixed(1) })} <em>{interpretTTE(te, language)}</em></p>}
      {tea > 0 && <p>{t('athleteDashboard.runningPhysio.teaSentence', { value: tea.toFixed(1) })} <em>{interpretTAE(tea, language)}</em></p>}
      <div className="mt-4">
        <h6 style={{ fontSize: 14, fontWeight: 700, color: '#193255' }}>📈 {t('athleteDashboard.runningPhysio.chartTitle')}</h6>
        <div id="chartdiv-strength" style={{ width: '100%', height: '400px' }} />
      </div>
    </div>
  );
};
export default StrengthPhysiologicalAnalysis;